// @flow
import React, { type Node, useEffect, useState } from "react";

type PropriedadesDoAtraso = {
  atraso?: number,
  children: ({ finalizado: boolean }) => Node,
};

export const Atraso = ({ atraso = 3000, children }: PropriedadesDoAtraso) => {
  const [finalizado, setFinalizado] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setFinalizado(true), atraso);
    return () => clearTimeout(timeout);
  }, [atraso, setFinalizado]);
  return children({ finalizado });
};

type PropriedadesDaRenderizacaoAtrasada = {
  atraso?: number,
  children: Node,
};
export const RenderizacaoAtrasada = ({
  children,
  ...props
}: PropriedadesDaRenderizacaoAtrasada) => (
  <Atraso {...props}>
    {({ finalizado }) => (finalizado ? children : null)}
  </Atraso>
);
